import { useGoogleOneTapLogin } from '@react-oauth/google';

import { $$toast } from '@doger/ui/components/ui/toast';

import { useJWT } from '../jwt';
import { useGoogleAuthMutation } from './google-auth.mutation';

type GoogleOneTapAuthProps = {
  disabled?: boolean;

  onSuccess?: (data: {
    accessToken: string;
    refreshToken: string;
    isExistingUser: boolean;
  }) => void;
};

export const GoogleOneTapAuth = ({
  disabled,
  onSuccess,
}: GoogleOneTapAuthProps) => {
  const jwt = useJWT();
  const mutation = useGoogleAuthMutation();

  useGoogleOneTapLogin({
    disabled: !!jwt || !!disabled,
    onSuccess(credentialResponse) {
      mutation.mutate(
        { token: credentialResponse.credential as string },
        { onSuccess }
      );
    },
    onError() {
      console.error('Google One Tap Auth error');
      $$toast.error('Failed to sign in. Please try other method.');
    },
  });

  return null;
};
